<div class="panel-content">
  <div [ngClass]="{ 'capture-selfie': isLojistaPiloto }">
    <webcam
      *ngIf="hasWebcam && showWebcam"
      [width]="500"
      [trigger]="webcamTrigger"
      (imageCapture)="handleImageCapture($event)"
      (initError)="handleErroWebcam($event)"
    ></webcam>
    <img
      *ngIf="!showWebcam && selfiePreview"
      [src]="selfiePreview"
      class="webcam-preview"
      alt="Foto Webcam"
    />

    <div *ngIf="isLojistaPiloto" class="capture-selfie_content">
      <div class="capture-selfie_content_dica" *ngIf="hasWebcam && showWebcam">
        <span
          >Centralize o rosto do cliente no circulo abaixo e aperte o botão para
          tirar a foto</span
        >
      </div>
    </div>
  </div>

  <div *ngIf="isLojistaPiloto">
    <div
      *ngIf="hasErrorBiometriaAssessment"
      class="text-orange aviso-biometria"
    >
      <span class="fa fa-ban mr-5"></span>
      Essa foto não foi aprovada!
      <a class="text-orange underline ml-5" (click)="onClickSaibaMais()"
        >Saiba mais.</a
      >
    </div>

    <div *ngIf="hasBiometriaCreditRequest" class="aviso-biometria-sucesso">
      <span class="fa fa-check-circle-o mr-5"></span>
      Biometria realizada.
    </div>
  </div>

  <div *ngIf="hasWebcam && showWebcam" class="btn-tirar-foto">
    <app-btn-small
      color="primary"
      title="Tirar uma foto"
      (click)="onClickTirarUmaFoto()"
      [isDisabled]="!isEnabledFotoAndEnviar"
    >
      <span class="fa fa-camera mr-5 color-white"></span>
    </app-btn-small>
  </div>

  <div
    *ngIf="!isLojistaPiloto || (isLojistaPiloto && !hasBiometriaCreditRequest)"
  >
    <div *ngIf="!showWebcam && !isAceitaImagem" class="btn-tirar-foto pt-0">
      <app-btn-small
        color="blue"
        title="Trocar foto"
        (click)="onClickTirarOutraFoto()"
        [isDisabled]="!isEnabledFotoAndEnviar"
      >
        <span class="fa fa-camera mr-5"></span>
      </app-btn-small>

      <app-btn-small
      *ngIf="showSaveButton"
        color="primary"
        title="Enviar foto"
        (click)="onClickEnviar()"
        [isDisabled]="!selfiePreview"
      >
        <span class="fa fa-camera mr-5"></span>
      </app-btn-small>
    </div>
  </div>

  <div class="panel-content" *ngIf="!hasWebcam">
    <p class="text-vermelho p-0">
      {{ textoErroWebcam }}
    </p>
  </div>

  <div class="m-spacing" *ngIf="!showSaveButton">
    <a
      class="text-center text-orange underline pt-0"
      (click)="selfieInput.click()"
    >
      Não foi possível fotografar o cliente?<br />
      <span class="fa fa-file-image-o"></span>
      Clique aqui para anexar a foto.
    </a>
  </div>

  <div class="box gray-box w-100" *ngIf="!isAceitaImagem">
    <div class="box-title">Dicas de captura</div>
    <ul class="box-content">
      <li>Manter distância máxima de 40cm da câmera.</li>
      <li>Estar enquadrado na tela.</li>
      <li>Não realizar expressão facial, por exemplo, sorrir.</li>
      <li>Não utilizar acessórios, como: óculos, boné, gorro, etc.</li>
    </ul>
  </div>

  <div class="box success-box w-100" *ngIf="isAceitaImagem">
    <p><span class="fa fa-check pr-15"></span>Imagem enviada com sucesso!</p>
  </div>
</div>

<span class="hidden">
  <input
    #selfieInput
    type="file"
    (change)="selecionarSelfieManual($event)"
    [accept]="ACCEPT_IMAGES"
  />
</span>
